"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalLayouts = void 0;
const UiKitLite_1 = require("../UiKitLite");
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const HorizontalLayouts = () => (react_1.default.createElement(react_2.HStack, { spacing: 5 },
    react_1.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { flex: 1 },
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "ONE")),
    react_1.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { flex: 1 },
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "TWO")),
    react_1.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { flex: 1 },
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "THREE")),
    react_1.default.createElement(UiKitLite_1.UiKitLite.InfoBox, { flex: 1 },
        react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "FOUR"))));
exports.HorizontalLayouts = HorizontalLayouts;
